var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogNetworkStylesheet = function SvgLogNetworkStylesheet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19332_57956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4807 2.86133C12.9587 2.33933 12.1221 2.312 11.5667 2.79733L6.20874 7.48533C5.62807 7.99333 5.59874 8.886 6.14407 9.43133L6.91007 10.1973C7.4554 10.7427 8.34874 10.7127 8.85607 10.1327L13.5441 4.77467C14.0301 4.22 14.0021 3.38333 13.4807 2.86133Z",
    stroke: "#D75ED7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24658 6.57999L9.76658 9.09999",
    stroke: "#D75ED7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.39943 13.5487H4.8681C6.8581 13.5487 7.85477 11.1427 6.44743 9.73532C5.41277 8.70065 3.65543 9.08132 3.1421 10.4513L2.12743 13.1567C2.05677 13.3467 2.19677 13.5487 2.39943 13.5487Z",
    stroke: "#D75ED7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19332_57956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
export { SvgLogNetworkStylesheet as ReactComponent };
export default __webpack_public_path__ + "log-network-stylesheet.svg";